module.exports = __webpack_public_path__ + "static/media/document-img.06d99308.svg";